module.exports = "<img #img>";